/*
 * map initiator is in charge of download the needed dependencies for having
 * a map in your page. Include this JS in the bundle of your page and call the
 * MapInitiator with the configuration you want for the map. Check out the
 * readMe file for details about the configuration object.
 */
(function mapInitiator(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Map = global.NewHomeSource.Map || {};
  const scriptBundleElement = document.querySelector('#mapBundle');
  const isMobileDevice = document.querySelector('[data-ismobiledevice="true"]');

  if (!isMobileDevice && !scriptBundleElement &&
    (!global.NHS || !global.NHS.loadJs)) {
    if (!global.google || !global.google.maps || !global.NewHomeSource.BaseMap) {
      return;
    }
  }

  const previousMapInitiator = global.NewHomeSource.Map.MapInitiator;

  function loadMapResourcesDesktop(mapConfiguration) {
    if (global.google && global.google.maps) {
      NHS.loadJs(scriptBundleElement.value,
        'mapBundle',
        () => {
          global.NewHomeSource.Map.BaseMap(mapConfiguration);
        });
    } else {
      document.body.addEventListener('googleScriptLoadedAcknowledgement', () => {
        if (global.NewHomeSource.Map.BaseMap) {
          global.NewHomeSource.Map.BaseMap(mapConfiguration);
          return;
        }

        if (mapConfiguration.mapContainer.parentElement.parentElement.style.display !== 'none') {
          if (global.NewHomeSource.Map.BaseMap) {
            if (global.NewHomeSource.Map.BaseMap.isMapCreated()) {
              return;
            } else {
              global.NewHomeSource.Map.BaseMap(mapConfiguration);
              return;
            }
          }

          NHS.loadJs(scriptBundleElement.value,
            'mapBundle',
            () => {
              global.NewHomeSource.Map.BaseMap(mapConfiguration);
            });
        }
      });

      document.body.dispatchEvent(new CustomEvent('askForGoogleScript'));
    }
  }

  function loadMapResourcesMobile(mapConfiguration) {
    const bundle = mapConfiguration.bundleName ? mapConfiguration.bundleName : 'mobileMapBundlePlaceHolder';
    require([bundle], () => {
      global.NewHomeSource.Map.BaseMap(mapConfiguration);
    }, function () {
      // If the RequireJS module fails to load (e.g., config not yet loaded),
      // fall back to loading the map bundle via NHS.loadJs if available.
      if (scriptBundleElement && global.NHS && global.NHS.loadJs) {
        loadMapResourcesDesktop(mapConfiguration);
      }
    });
  }

  /**
   * @constructs NewHomeSource.Map.MapInitiator
   */
  function MapInitiator(mapConfiguration) {
    if (!mapConfiguration || !mapConfiguration.mapContainer) {
      return;
    }

    if (global.NewHomeSource.Map.BaseMap) {
      global.NewHomeSource.Map.BaseMap(mapConfiguration);
      return;
    }

    // if we're on mobile devices or require is defined, load the mobile resources.
    if (isMobileDevice || typeof require !== 'undefined') {
      loadMapResourcesMobile(mapConfiguration);
    } else {
      loadMapResourcesDesktop(mapConfiguration);
      scriptBundleElement.parentElement.removeChild(scriptBundleElement);
    }
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Map.MapInitiator to the previous script.
   */
  MapInitiator.noConflict = function noConflict() {
    global.NewHomeSource.Map.MapInitiator = previousMapInitiator;
    return MapInitiator;
  };

  global.NewHomeSource.Map.MapInitiator = MapInitiator;
}(window));

define("mapInitiator", function(){});

